@if (activePreview === this.quotePreviewType.pdf && loading) {
  <div class="loading">
    <app-spinner [size]="50"></app-spinner>
    @if (!source) {
      <span>Loading</span>
    }
    @if (source) {
      <span>Updating</span>
    }
    <span> preview...</span>
  </div>
}

@if (source && activePreview === this.quotePreviewType.pdf) {
  <pdf-viewer
    data-cy="quote-pdf-viewer"
    style="width: 99.9%; min-height: 1000px"
    [src]="source"
    [zoom]="1"
    [original-size]="false"
    [show-all]="true"
    [class.dimmed]="!!loading"
    [class.rendered]="rendered"
    [class.full-height]="isFullHeight"
    (page-rendered)="onPageRendered()"
    (after-load-complete)="afterLoadComplete()"
  >
  </pdf-viewer>
}

@if (activePreview === this.quotePreviewType.xls) {
  <div class="tariff-download">
    <button
      pButton
      size="large"
      severity="secondary"
      aria-hidden="true"
      (click)="fetchPreviewCheck()"
      [disabled]="loading"
    >
      @if (loading) {
        <app-spinner [size]="15"></app-spinner>
      }
      @if (!loading) {
        <i class="pi pi-server"></i>
      }
      Request preview
    </button>
    @if (source) {
      <a
        pButton
        size="large"
        severity="success"
        aria-hidden="true"
        [href]="source"
        (click)="source = null"
        target="_blank"
      >
        <i class="pi pi-download"></i> Download preview
      </a>
    }
  </div>
}
